import styled from 'styled-components';

export const Next = styled.td.withConfig({ displayName: '-Next' })`
	width: 48px;
  color: #afafaf;
  font-size: 20px;
  text-align: right !important;
`;
